import './Footer.css'

function Footer() {
  return (
    <footer className="customer-footer">
      <a
        href="/"
        className="footer-link"
      >
        сайт поддерживается сервисом quokka
      </a>
    </footer>
  )
}

export default Footer
